import React from "react";
import ProductLayout from "../components/ProductLayout";

const ProductDetails = () => {
  return <ProductLayout />;
};

export default ProductDetails;
